import React, { useMemo } from 'react'

import { useTheme } from '@mui/material'

import TableRow from 'components_new/atoms/Table/TableRow'

import HeaderCell from '../HeaderCell'

import { ORDER_BY_SEGMENT_BY } from '../utils'
import { TableColumn, TableDataType } from '../index'

interface HeaderRowProps {
  columns: TableColumn[]
  display: boolean
  horizontal: boolean
  measureSegmentCell?: (cell: HTMLTableCellElement | null) => void
  scaleFactor: number
  segmentBy: string
  segmentWidth: number
  verticalDividers: boolean
  onSort?: (id: string, index: number | null) => void
  order?: 'asc' | 'desc'
  orderBy?: { id: string | null; index: number | null }
}

const HeaderRow = (props: HeaderRowProps) => {
  const {
    columns,
    display,
    horizontal,
    measureSegmentCell,
    scaleFactor,
    segmentBy,
    segmentWidth,
    verticalDividers,
    onSort,
    order,
    orderBy
  } = props

  const headerCells = useMemo(
    () =>
      columns.map((column, i) => (
        <HeaderCell
          key={i}
          divider={verticalDividers}
          label={column.label}
          scaleFactor={scaleFactor}
          type={horizontal ? TableDataType.NUMBER : column.type}
          active={
            orderBy
              ? column.id === orderBy.id && column.index === orderBy.index
              : false
          }
          onClick={onSort ? () => onSort(column.id, column.index) : undefined}
          order={order}
          // the total column is pinned right after the segment column
          stickyLeft={column.isTotal ? segmentWidth : undefined}
          // Next release:
          // numberOfCharacters={column.numberOfCharacters}
        />
      )),
    [
      columns,
      order,
      orderBy,
      scaleFactor,
      horizontal,
      segmentWidth,
      verticalDividers,
      onSort
    ]
  )

  const theme = useTheme()

  return display ? (
    <TableRow
      sx={{
        bgcolor: theme.palette.background.widget,
        backgroundImage: `linear-gradient(${theme.palette.background.overlay}, ${theme.palette.background.overlay})`
      }}
    >
      <HeaderCell
        divider={verticalDividers}
        label={segmentBy}
        measureRef={measureSegmentCell}
        scaleFactor={scaleFactor}
        stickyLeft={0}
        type={TableDataType.STRING}
        active={orderBy ? ORDER_BY_SEGMENT_BY === orderBy.id : false}
        onClick={onSort ? () => onSort(ORDER_BY_SEGMENT_BY, null) : undefined}
        order={order}
      />
      {headerCells}
    </TableRow>
  ) : null
}

export default HeaderRow
